import { isIOS } from 'wap/hybrid/device.js'
import { appLinks } from '@ms/config/app'
import { openDialog } from '@ms/ui/dialog'

// 跳转/下载默认 android app
export function downloadDefaultApp() {
  if (isIOS()) {
    location.href = appLinks.appIosAppleStore
  } else {
    location.href = appLinks.appAndroidApk
  }
}

/**
 * Opens a dialog to download the MSport App.
 *
 * @param {string} [message=''] - The message to display in the dialog.
 * @param {Function} [onConfirm] - The callback function to execute when the confirm button is clicked. If not provided, the default app download function will be called.
 * @returns {Object} - The dialog instance.
 */
export const dialogDownloadApp = (message = '', onConfirm) => {
  return openDialog({
    title: 'Download MSport App',
    message,
    confirmButtonText: 'Free Download',
    cancelButtonText: 'Cancel',
    showClose: true,
    closeOnClickModal: true,
    onConfirm: onConfirm
      ? onConfirm
      : () => {
          downloadDefaultApp()
        }
  })
}
